import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 25px;
  }
`;
const BrandLogo = styled.img`
  cursor: pointer;
`;
const Links = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;

  @media (max-width: 900px) {
    justify-content: space-between;
    margin-top: 10px;
    border: 1px solid #999;
    padding: 15px 25px;
    border-radius: 25px;
  }
`;
const Link = styled.div`
  font-size: 18px;
  font-weight: 400;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export default function Nav() {
  let navigation = useNavigate();
  return (
    <Container>
      <BrandLogo
        onClick={() => {
          navigation("/");
        }}
        src="/entire-logo.svg"
      />
      <Links>
        <Link
          onClick={() => {
            navigation("/");
          }}
        >
          Home
        </Link>
        <Link
          onClick={() => {
            navigation("/about-us");
          }}
        >
          About
        </Link>
        <Link
          onClick={() => {
            navigation("/contact-us");
          }}
        >
          Contact Us
        </Link>
      </Links>
    </Container>
  );
}
